var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpreadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 31.438,
    viewBox: "0 0 42 31.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M20.736,31.438a1,1,0,0,1-.788-.385L16,26H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H37a5.006,5.006,0,0,1,5,5V21a5.006,5.006,0,0,1-5,5H26l-4.516,5.1A1,1,0,0,1,20.736,31.438ZM17.174,6a3.985,3.985,0,0,0-2.62.957,4.407,4.407,0,0,0-1.549,3.177,4.479,4.479,0,0,0,1.239,3.321L20.291,19.7a.979.979,0,0,0,1.415,0l6.047-6.244A4.479,4.479,0,0,0,29,10.133a4.4,4.4,0,0,0-1.548-3.176A3.986,3.986,0,0,0,24.827,6a4.506,4.506,0,0,0-3.211,1.383L21,8.016l-.616-.634A4.5,4.5,0,0,0,17.174,6Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadIcon);
export default __webpack_public_path__ + "static/media/spreadIcon.1ae21040ece3b773651dae86c8840199.svg";
export { ForwardRef as ReactComponent };